import { AuthService } from './../../core/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { User } from '../../core/user';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {

  showSpinner: boolean = true;
  userCollection: AngularFirestoreCollection<User>;
  users: Observable<User[]>;
  userList: any;
  userData: any;
  id: number;
  private sub: any;

  readonly path = 'users';

  userDocs: Observable<User[]>;

  constructor(public afs: AngularFirestore, private route: ActivatedRoute,private router: Router, private authService: AuthService) {

  }


  getList(): Observable<User[]>{
    return this.afs.collection<User>(this.path)
    .snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as User;
        const id = a.payload.doc.id;
        this.showSpinner = false;
        return { id, ...data };
      });
    });
  }

  deleteUser(id) {
    var result = confirm("Are you sure you want to delete?");
    if (result) {
      var deleteDoc = this.afs.collection('users').doc(id).delete();
      // var deleteDoc = this.afs.collection('posts' , ref => ref.where('calendar_id', '==' , id)).doc(id).delete();
    }
  }


  ngOnInit() {
    if (this.authService.loggedInUserRole !== 'Admin') {
      this.router.navigate(['/home'])
    }
    // this.showSpinner = true;
    this.userDocs = this.getList();
    
  }
}


// WEBPACK FOOTER //
// ./src/app/auth/user-info/user-info.component.ts